import React, { ReactNode } from 'react';
import { FmlxCard } from 'fmlx-common-ui';

interface DropContentInfoCardProps {
  header: string;
  contents?: string[];
  icon: ReactNode;
}

export const DropContentInfoCard = ({
  header,
  contents,
  icon,
}: DropContentInfoCardProps) => {
  return (
    <FmlxCard
      disabled={false}
      selected={false}
      selectable={false}
      draggable={false}
      variant="outlined"
      type={undefined}
    >
      <FmlxCard.Body className="flex flex-row p-1 items-center w-full">
        <div className="m-1 mr-2 shrink-0">{icon}</div>
        <div className="flex flex-col min-w-0">
          <div className="w-full truncate text-xs font-medium font-[roboto]">
            {header}
          </div>
          {contents?.map((content, idx) => {
            return (
              <div className="text-xs font-[roboto] text-[#5D5D5D] truncate" key={idx}>
                {content}
              </div>
            );
          })}
        </div>
      </FmlxCard.Body>
    </FmlxCard>
  );
};
